import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import expander from 'views/assets/scripts/expander'
import floatingLabel from 'views/assets/scripts/floatingLabel'
import formControlValidation from 'views/assets/scripts/formValidation/formControlValidation'
import passwordReveal from 'views/assets/scripts/passwordReveal'
import select from 'views/assets/scripts/select'
import CartOrganism from 'views/components/organisms/Cart'

const CartContainer = () => {
  // This will rerender the whole cart if the object reference changes. That may be to many rerenderings.
  const cartRedux = useSelector(state => state.cart.data)
  useEffect(() => {
    expander()
    floatingLabel()
    passwordReveal()
    formControlValidation()
    select()
  }, [])

  return (
    <div className="l-grid__item u-margin-x-large--bottom">
      {cartRedux && <CartOrganism />}
    </div>
  )
}

export default CartContainer
